import * as React from "react";
import Text from "@warda/library-ui/core/Text";
import { Initialize, Severity } from "@warda/library-ui/interfaces";
import getErrorMsg from "@warda/library-ui/utils/getErrorMsg";
import { getTheme } from "@warda/library-ui/theme";
import { v4 as uuidv4 } from "uuid";
import { useAppWebSocketCtx } from "@warda/library-ui/contexts/AppWebSocketContext";
import inLoading from "@warda/library-ui/utils/inLoading";
import Dialog from "./Dialog";
import { ACT_VPORT } from "./reducer";
import { RENDITION } from "../../interfaces";
import LinkSelection from "../AreaMediaLibrary/AreaFiles/LinkSelection";
import getIdsFile from "../AreaMediaLibrary/AreaFiles/utils/getIdsFile";
import { getSharePageUrlFirmed, SharePageDownloadMassive, } from "../../api/fetchesApiSharePage";
import apiUrls from "../../api/apiUrlsSharePage";
import { directDownload } from "../../utils/directDownloadMedia";
import { getSharePageAuthorization } from "./accessCodeUtil";
import { useContextDispatchViewport } from "./SharePage";
import { useContextSetSnackbar } from "../Main";
const DialogConfirmDownload = ({ open, files, filesSlcId, pageHrchId, handleError, }) => {
    const setSnackbar = useContextSetSnackbar();
    const dispatchViewport = useContextDispatchViewport();
    const appWebSocketCtx = useAppWebSocketCtx();
    const [initConfirm, setInit] = React.useState(Initialize.NONE);
    const cbOnApply = React.useCallback(() => {
        setInit(Initialize.START);
    }, []);
    const cbOnClose = React.useCallback(() => {
        dispatchViewport({ type: ACT_VPORT.DIALOG_DOWNLOAD, open: false });
    }, [dispatchViewport]);
    const loading = inLoading(initConfirm);
    React.useEffect(() => {
        if (!open)
            setInit(Initialize.NONE);
    }, [open]);
    React.useEffect(() => {
        if (initConfirm === Initialize.START) {
            (async () => {
                try {
                    setInit(Initialize.WAIT);
                    const { idsFolder, idsMedia } = getIdsFile(files, filesSlcId);
                    if (filesSlcId.length === 1 && idsMedia.length === 1) {
                        const file = files.find(({ id }) => id === filesSlcId[0]);
                        const fileData = file.data;
                        const { fileId, name } = fileData;
                        const authorizationRequired = !!getSharePageAuthorization();
                        const srcUrl = apiUrls.mediaDownload.url(fileId, undefined, name, authorizationRequired ? false : true);
                        const downloadUrl = authorizationRequired
                            ? await getSharePageUrlFirmed(srcUrl)
                            : srcUrl;
                        directDownload(downloadUrl);
                        setSnackbar(Severity.INFO, "Download media");
                    }
                    else {
                        const correlationId = uuidv4();
                        const { success, message } = await SharePageDownloadMassive({
                            correlationId,
                            connectionId: appWebSocketCtx.getWebSocketConnectionId(),
                            groups: [
                                {
                                    hierarchyId: pageHrchId,
                                    renditions: [RENDITION.original],
                                    folders: idsFolder,
                                    files: idsMedia,
                                },
                            ],
                        });
                        if (!success)
                            throw message;
                        dispatchViewport({
                            type: ACT_VPORT.DOWNLOADS_TO_ADD,
                            payload: {
                                correlationId,
                                filename: `${correlationId}.zip`,
                            },
                        });
                        setSnackbar(Severity.INFO, "Preparing zip download");
                    }
                    cbOnClose();
                }
                catch (err) {
                    handleError(err);
                    const errMsg = await getErrorMsg(err);
                    setSnackbar(Severity.WARN, errMsg);
                    setInit(Initialize.NONE);
                }
            })();
        }
    }, [
        appWebSocketCtx,
        cbOnClose,
        dispatchViewport,
        files,
        filesSlcId,
        initConfirm,
        pageHrchId,
        setSnackbar,
        handleError,
    ]);
    return (React.createElement(Dialog, { open: open, title: "Confirm download", loading: loading, onClose: cbOnClose, style: { padding: "5px 15px" }, buttons: [
            {
                label: "Download",
                onClick: cbOnApply,
            },
        ] },
        React.createElement(Text, { children: "Are you sure to download the current selection?" }),
        React.createElement(LinkSelection, { color: getTheme().colors.theme2, style: { padding: 0 }, files: files.filter((f) => filesSlcId.some((a) => a === f.id)) })));
};
export default DialogConfirmDownload;
